export default "__VITE_ASSET__52e0df16__"